import React, { useState } from 'react';

import {
    Box,
    Button,
    Card,
    Grid,
    Typography,
    Tooltip,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { Modal } from 'common/components';

import companyUsers from '../../companyUsers';
import * as actions from '../actions';

import SelectUserForm from './SelectUserForm';

const CardAssignUser = ({
    canModify,
    creditId,
    fetchCreditApplication,
    fetchUsers,
    financialAdvisor,
    users,
    userTracking,
}) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const handleOnClickAssignUser = () => setShowModal(true);
    const handleOnEnter = () => fetchUsers();
    const handleOnHide = () => setShowModal(false);
    const handleOnCallback = () => {
        fetchCreditApplication(creditId);
        setShowModal(false);
    };
    return (
        <Card>
            <Card.Body>
                <Grid container alignItems="start">
                    <Grid size={{ lg: 14, xs: 18 }}>
                        <Box display="flex" gap={1}>
                            <Typography fontWeight="bold" variant="caption">
                                {t('Financial advisor')}:
                            </Typography>
                            <Typography variant="caption">
                                {financialAdvisor !== null
                                    ? `${financialAdvisor?.first_name} ${financialAdvisor?.last_name} ${financialAdvisor?.second_surname}`
                                    : t('No user assigned')}
                            </Typography>
                        </Box>
                        <Box display="flex" gap={1}>
                            <Typography fontWeight="bold" variant="caption">
                                {t('Company executive')}
                            </Typography>
                            <Typography variant="caption">
                                {userTracking !== null
                                    ? `${userTracking?.first_name} ${userTracking?.last_name} ${userTracking?.second_surname}`
                                    : t('No user assigned')}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid
                        hidden={!canModify}
                        size={{ md: 4, xs: 18 }}
                        textAlign="right"
                    >
                        <Tooltip title={t('Request executive')}>
                            <Button
                                color="secondary"
                                onClick={handleOnClickAssignUser}
                                size="small"
                                variant="text"
                            >
                                {financialAdvisor === null
                                    ? t('Assign')
                                    : t('Change')}{' '}
                                {t('Executive')}
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Card.Body>

            <Modal
                onEnter={handleOnEnter}
                onHide={handleOnHide}
                show={showModal}
                size="sm"
                title={t('Assign request executive')}
            >
                <SelectUserForm
                    creditId={creditId}
                    callback={handleOnCallback}
                    users={users}
                />
            </Modal>
        </Card>
    );
};

const mapStateToProps = createStructuredSelector({
    users: companyUsers.selectors.getFetchItemsListData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchCreditApplication: (id) =>
        dispatch(actions.fetchCreditApplication(id)),
    fetchUsers: () => dispatch(companyUsers.actions.fetchItems()),
});

CardAssignUser.propTypes = {
    canModify: PropTypes.bool,
    creditId: PropTypes.string,
    fetchCreditApplication: PropTypes.func,
    fetchUsers: PropTypes.func,
    financialAdvisor: PropTypes.object,
    users: PropTypes.array,
    userTracking: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardAssignUser);
